<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Бизнес-компании</strong>
                </CCardHeader>
                <CCardBody>
                    <div v-if="loading" class="table__preloader">
                        <CSpinner color="primary" />
                    </div>
                    <CDataTable
                        v-else
                        hover
                        clickable-rows
                        :items="companies"
                        :fields="fields"
                        :items-per-page="30"
                        pagination
                        @row-clicked="openCompany"
                    >
                        <template #program_type="data">
                            <td>{{ programTypeLabel(data.item.program_type) }}</td>
                        </template>
                        <template #tariff_amount="data">
                            <td>{{ formatMoney(data.item.tariff_amount) }}</td>
                        </template>
                        <template #remaining_balance="data">
                            <td>{{ formatMoney(data.item.remaining_balance) }}</td>
                        </template>
                        <template #current_debt="data">
                            <td>{{ formatMoney(data.item.current_debt) }}</td>
                        </template>
                        <template #overdue="data">
                            <td>
                                <CBadge :color="isPaymentOk(data.item) ? 'success' : 'danger'">
                                    {{ paymentStatusLabel(data.item) }}
                                </CBadge>
                            </td>
                        </template>
                        <template #enabled="data">
                            <td>
                                <CBadge :color="data.item.enabled ? 'success' : 'secondary'">
                                    {{ data.item.enabled ? 'Активна' : 'Отключена' }}
                                </CBadge>
                            </td>
                        </template>
                    </CDataTable>
                </CCardBody>
                <CCardFooter>
                    <CButton color="primary" @click="$router.push('/business-companies/create')">
                        Создать компанию
                    </CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'BusinessCompanies',
        data() {
            return {
                loading: true,
                companies: [],
                fields: [
                    { key: 'id', label: 'ID' },
                    { key: 'title', label: 'Название' },
                    { key: 'program_type', label: 'Программа' },
                    { key: 'tariff_amount', label: 'Тариф' },
                    { key: 'remaining_balance', label: 'Остаток' },
                    { key: 'current_debt', label: 'Долг' },
                    { key: 'members_count', label: 'Профили' },
                    { key: 'overdue', label: 'Оплата' },
                    { key: 'enabled', label: 'Статус' }
                ]
            };
        },
        async mounted() {
            try {
                const { data } = await Vue.axios.get('/companies');
                this.companies = data;
            } catch (err) {
                this.$root.$emit('showError', 'Ошибка загрузки компаний.');
            } finally {
                this.loading = false;
            }
        },
        methods: {
            openCompany(item) {
                this.$router.push(`/business-companies/${item.id}`);
            },
            programTypeLabel(type) {
                return type === 'installment' ? 'Рассрочка' : 'Предоплата';
            },
            formatMoney(value) {
                return `${Number(value || 0).toLocaleString('ru-RU')} ₽`;
            },
            isPaymentOk(item) {
                return !item.overdue && !(Number(item.current_debt) > 0);
            },
            paymentStatusLabel(item) {
                if (this.isPaymentOk(item)) {
                    return 'Ок';
                }
                return item.overdue ? 'Просрочено' : 'Долг';
            }
        }
    };
</script>
